import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "language-switcher inline-flex items-center rounded-md border border-primary overflow-hidden h-7 relative" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute h-full bg-primary transition-transform duration-300 ease-in-out",
      style: _normalizeStyle({ width: '50%', transform: `translateX(${_ctx.currentLocale === 'en' ? '0%' : '100%'})` })
    }, null, 4),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (locale) => {
      return (_openBlock(), _createElementBlock("button", {
        key: locale.code,
        onClick: ($event: any) => (_ctx.changeLanguage(locale.code)),
        class: _normalizeClass(["px-2 py-0.5 text-xs font-medium transition-all duration-300 ease-in-out min-w-[28px] flex items-center justify-center relative z-10", { 
        'text-white': _ctx.currentLocale === locale.code, 
        'text-gray-700 hover:text-gray-900': _ctx.currentLocale !== locale.code 
      }])
      }, _toDisplayString(locale.displayName), 11, _hoisted_2))
    }), 128))
  ]))
}